module.exports = __webpack_public_path__ + "images/index/link02.3af00ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link/link02.png
// module id = B63R
// module chunks = 21